<div class="banner">
  <div class="jumbotron" style="text-align: center">
    <h1>How to use the SDG classification service</h1>
    <p>Classify your arbitrary text with the help of the Aurora-SDG-classifier</p>
  </div>
</div>

<div class="container-fluid content-container">
  <div class="content">
    <h1 class="results-heading">Introduction Video</h1>
    <div class="grid">
      <div class="sm:col-12 md:col-10 lg:col-8 xl:col-6 md:col-offset-1 lg:col-offset-2 xl:col-offset-3">
        <div class="grid flex">
          <div class="col-12 centered">
            <iframe width="1200" height="800" sandbox="allow-scripts allow-popups allow-forms allow-same-origin allow-popups-to-escape-sandbox allow-downloads allow-modals" aria-label="YouTube Video, Aurora SDG Classifier" src="https://www.youtube.com/embed/3dmX1CGdINM" allowfullscreen="" data-dashlane-frameid="753"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
